import { useEffect, useState } from "react";
import { LoginMain } from "../../styles/login";
import { FormLogin } from "./loginForm";
import { SquareLoading } from "../../components/loaders";

export const Login = () => {
  const [mobileAppOn, setMobileAppOn] = useState(false);

  useEffect(() => {
    if (window.ReactNativeWebView) {
      setMobileAppOn(true);
    }
  }, []);

  return (
    <LoginMain>{mobileAppOn ? <SquareLoading /> : <FormLogin />}</LoginMain>
  );
};
